import * as React from 'react';
import * as sanitizeHtml from 'sanitize-html';

const defaultOptions = {
  allowedTags: [ 'br', 'a' ],
  allowedAttributes: {
    'a': [ 'href', 'class', 'target' ]
  },
};

const sanitize = (html: string, options: sanitizeHtml.IOptions) => ({
  __html: sanitizeHtml(
    html, 
    options = {...defaultOptions, ...options}
  )
});

export const SanitizeHTML = ({ html, options = defaultOptions }) => (
  <div dangerouslySetInnerHTML={sanitize(html, options)} />
);
